import { connect } from 'react-redux';
import { getTotalCost } from '../../../containers/ticketSelection/utils/getTotalCost';
import { getLocaleProps, getTicketsPageSize } from '../../../selectors/app';
import { getCanMakePaymentsWithActiveCard } from '../../../selectors/applePay';
import { getRoutePathname } from '../../../selectors/routing';
import { getSelectedTickets } from '../../../selectors/tickets/getSelectedTickets';
import { CheckoutState } from '../../../state';
import { ApplepayNativeButtonProps } from './ApplepayNativeButton';

const mapStateToProps = (
    state: CheckoutState,
): Pick<
    ApplepayNativeButtonProps,
    | 'canMakePaymentsWithActiveCard'
    | 'defaultLocale'
    | 'pathname'
    | 'ticketsCost'
    | 'ticketsPageSize'
> => ({
    canMakePaymentsWithActiveCard: getCanMakePaymentsWithActiveCard(state),
    defaultLocale: getLocaleProps(state).defaultLocale,
    pathname: getRoutePathname(state),
    ticketsCost: getTotalCost(getSelectedTickets(state)),
    ticketsPageSize: getTicketsPageSize(state),
});

export type ConnectedProps = ReturnType<typeof mapStateToProps>;

export const connectApplepayNativeButton = connect(mapStateToProps);
